(function () {
    "use strict";

    // @ngInject
    function NewAddNetworkProjectContributorControllerCtor($scope, $modalInstance, $injector, $q, $translate, ContactsManager, UsersManager, UserService, _, CompanyService, ModelFactory, NetworkManager,
                                                           GoogleAPIService, AnalyticsService, SearchablesManager, PopupMessageService, project, ValidationsManager) {

        this.constructor.$super.call(this, $scope, $modalInstance, $injector, $translate, UsersManager, UserService, _, CompanyService, ModelFactory, NetworkManager, GoogleAPIService, AnalyticsService, SearchablesManager, ValidationsManager);
        this.__objectType = 'NewAddNetworkProjectContributorController';

        this.alertForExistingUsers = true;
        this.ContactsManager = ContactsManager;
        this.NetworkManager = NetworkManager;
        this.PopupMessageService = PopupMessageService;
        this.project = project;
        this.isVendor = true;
        this.isVendorEditDisabled = true;
        this.user.system_user_type = 'vendor';
        this.$q = $q;

        this.isSuggestFromVendorContacts = true;
        this.isSuggestFromGmailContacts = true;
        this.titleText = $translate.instant("NETWORK.TAG_VENDOR._HEADER_TITLE_");
        this.subTitleText = '';
        this.ctaText = $translate.instant("ADD_USER_DIALOG.NEW_ADD_USER_MODAL._ADD_");
    }

    Controllers.NewAddNetworkProjectContributorController = Class(Controllers.NewAddUserController, {

        constructor: NewAddNetworkProjectContributorControllerCtor,

        saveUser: function saveUser() {
            var defer = this.$q.defer();
            var user = this.user;
            this.NetworkManager.addNetworkUserFromProject(user, this.project).then(
                function success(resp) {
                    user = user.mixinFrom(resp.data);
                    if (this.project.members) {
                        this.project.members.push(user);
                        this.project.member_ids.push(user._id);
                    } else {
                        this.project.members = [user];
                        this.project.member_ids = [user._id];
                    }

                    this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_vendor_tagged_in_project,
                        {
                            project_id: this.project._id,
                            new_member_email: user.email,
                            new_member_id: user._id,
                            new_member_full_name: user.full_name
                        });
                    defer.resolve(user);

                }.bind(this),

                function error(resp) {
                    defer.reject(resp);
                }.bind(this)
            );
            return defer.promise;
        },

        handleUserFromDb: function handleUserFromDb(dbUser) {
            if (dbUser.email) {
                if (!dbUser.isVendor()) {
                    this.user.email = null;
                    this.attemptToAddAClientUser();
                    return;
                }
                if (this.attemptToAddUserExistingInTheSystem(dbUser._id)) {
                    this.user.email = null;
                    return;
                }

                this.user = dbUser;
            }
            else { //user doesn't exist
                this.user._id = null; // user doesn't exist yet (it will also remove the avatar).
            }
        },

        attemptToAddAClientUser: function attemptToAddAClientUser() {
            this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'NETWORK.TAG_VENDOR._CANNOT_ADD_CLIENT_USER_', function () {
            });
        },

        attemptToAddUserExistingInTheSystem: function attemptToAddUserExistingInTheSystem(userId) {
            var isProjectMember = false;
            if (this.project.members) {
                this.project.members.forEach(function (member) {
                    if (member._id === userId) {
                        isProjectMember = true;
                    }
                });
            }
            if (isProjectMember) {
                this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'NETWORK.TAG_VENDOR._CANNOT_ADD_ADDED_USER_', function () {
                });
                return true;
            }
        }
    });
}());

